// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification {
  width: 100%;
  display: flex;
  min-height: 50px;
  border-radius: 3px;
  background-color: white;
  box-shadow: 0px 2px 3px 1px rgba(128, 128, 128, 0.356);
}
.notification .notification-line-left {
  border-radius: 3px 0px 0px 3px;
  width: 100%;
  max-width: 4px;
}
.notification .notification-line-top {
  height: 4px;
  border-radius: 3px 3px 0px 0px;
}
.notification .notification-line-default {
  display: none;
}
.notification .notification-line-primary {
  background-color: rgb(23, 116, 130);
}
.notification .notification-line-warning {
  background-color: rgb(207, 151, 0);
}
.notification .notification-line-info {
  background-color: rgb(18, 162, 181);
}
.notification .notification-line-error {
  background-color: red;
}
.notification .notification-box {
  border-radius: 3px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  justify-content: center;
}
.notification .notification-box .notification-box-title {
  font-size: 17px;
  font-weight: 500;
}
.notification .notification-box .notification-box-content {
  font-size: 12px;
}

.notification-top {
  flex-direction: column;
}

.notification-type-white {
  background-color: white;
}

.notification-type-green {
  background-color: rgb(41, 167, 68);
  color: white;
}

.notification-type-red {
  background-color: #dc3546;
  color: white;
}

@media only screen and (max-width: 792px) {
  .notification-hidden-mobile {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/Notification/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sDAAA;AACJ;AAAI;EACI,8BAAA;EACA,WAAA;EACA,cAAA;AAER;AAAI;EACI,WAAA;EACA,8BAAA;AAER;AAAI;EACI,aAAA;AAER;AAAI;EACI,mCAAA;AAER;AAAI;EACI,kCAAA;AAER;AAAI;EACI,mCAAA;AAER;AAAI;EACI,qBAAA;AAER;AAAI;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AAER;AADQ;EACI,eAAA;EACA,gBAAA;AAGZ;AADQ;EACI,eAAA;AAGZ;;AACA;EACI,sBAAA;AAEJ;;AAAA;EACI,uBAAA;AAGJ;;AADA;EACI,kCAAA;EACA,YAAA;AAIJ;;AAFA;EACI,yBAAA;EACA,YAAA;AAKJ;;AAFA;EACI;IACI,wBAAA;EAKN;AACF","sourcesContent":[".notification {\n    width: 100%;\n    display: flex;\n    min-height: 50px;\n    border-radius: 3px;\n    background-color: white;\n    box-shadow: 0px 2px 3px 1px rgba(128, 128, 128, 0.356);\n    .notification-line-left {\n        border-radius: 3px 0px 0px 3px;\n        width: 100%;\n        max-width: 4px;\n    }\n    .notification-line-top {\n        height: 4px;\n        border-radius: 3px 3px 0px 0px;\n    }\n    .notification-line-default{\n        display: none;\n    }\n    .notification-line-primary {\n        background-color: rgb(23, 116, 130);\n    }\n    .notification-line-warning {\n        background-color: rgb(207, 151, 0);\n    }\n    .notification-line-info {\n        background-color: rgb(18, 162, 181);\n    }\n    .notification-line-error {\n        background-color: red;\n    }\n    .notification-box {\n        border-radius: 3px;\n        padding: 10px;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        width: 100%;\n        justify-content: center;\n        .notification-box-title {\n            font-size: 17px;\n            font-weight: 500;\n        }\n        .notification-box-content{\n            font-size: 12px;\n        }\n    }\n}\n.notification-top {\n    flex-direction: column;\n}\n.notification-type-white{\n    background-color: white;\n}\n.notification-type-green{\n    background-color: rgb(41 167 68);\n    color: white;\n}\n.notification-type-red{\n    background-color: #dc3546;\n    color: white;\n}\n\n@media only screen and (max-width: 792px) {\n    .notification-hidden-mobile{\n        display: none !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
